import { Box } from '@wix/design-system';
import React from 'react';
import { SelectProductButton, } from '../../SelectProductButton';
export const ProductCardButton = ({ text, onClick, dataHook, ...props }) => {
    return (React.createElement(Box, { width: "80%", align: "center", ...props },
        React.createElement(SelectProductButton, { text: text, fullWidth: true, onClick: onClick, dataHook: dataHook, ...props })));
};
//# sourceMappingURL=ProductCardButton.js.map